import Loadable from '~/components/LoadableErrorReload';

const LoginWelcome = Loadable(() => import('~/pages/auth/login/LoginWelcome'));

const LoginRoute = () => {
  return <LoginWelcome />;
};

export default LoginRoute;
